// extracted by mini-css-extract-plugin
export default {"goodsRecommond":"index_goodsRecommond__eCuaz","goodsRecommondTitle":"index_goodsRecommondTitle__PS1U-","flag":"index_flag__coo1w","text":"index_text__Uzs-g"};